import { defineComponent as h, openBlock as o, createElementBlock as e, mergeProps as s, unref as n, renderSlot as d, createElementVNode as l, createCommentVNode as m } from "vue";
import { useScalarIcon as v } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, i = { key: 1 }, p = { key: 2 }, u = { key: 3 }, M = { key: 4 }, g = { key: 5 }, f = {
  name: "ScalarIconGridFour"
}, y = /* @__PURE__ */ h({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(V) {
    const a = V, { bind: r, weight: H } = v(a);
    return (Z, t) => (o(), e("svg", s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(r)), [
      d(Z.$slots, "default"),
      n(H) === "bold" ? (o(), e("g", A, t[0] || (t[0] = [
        l("path", { d: "M200,36H56A20,20,0,0,0,36,56V200a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V56A20,20,0,0,0,200,36Zm-4,80H140V60h56ZM116,60v56H60V60ZM60,140h56v56H60Zm80,56V140h56v56Z" }, null, -1)
      ]))) : n(H) === "duotone" ? (o(), e("g", i, t[1] || (t[1] = [
        l("path", {
          d: "M208,56V200a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,80H136V56h64ZM120,56v64H56V56ZM56,136h64v64H56Zm144,64H136V136h64v64Z" }, null, -1)
      ]))) : n(H) === "fill" ? (o(), e("g", p, t[2] || (t[2] = [
        l("path", { d: "M216,56v60a4,4,0,0,1-4,4H136V44a4,4,0,0,1,4-4h60A16,16,0,0,1,216,56ZM116,40H56A16,16,0,0,0,40,56v60a4,4,0,0,0,4,4h76V44A4,4,0,0,0,116,40Zm96,96H136v76a4,4,0,0,0,4,4h60a16,16,0,0,0,16-16V140A4,4,0,0,0,212,136ZM40,140v60a16,16,0,0,0,16,16h60a4,4,0,0,0,4-4V136H44A4,4,0,0,0,40,140Z" }, null, -1)
      ]))) : n(H) === "light" ? (o(), e("g", u, t[3] || (t[3] = [
        l("path", { d: "M200,42H56A14,14,0,0,0,42,56V200a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V56A14,14,0,0,0,200,42Zm2,14v66H134V54h66A2,2,0,0,1,202,56ZM56,54h66v68H54V56A2,2,0,0,1,56,54ZM54,200V134h68v68H56A2,2,0,0,1,54,200Zm146,2H134V134h68v66A2,2,0,0,1,200,202Z" }, null, -1)
      ]))) : n(H) === "regular" ? (o(), e("g", M, t[4] || (t[4] = [
        l("path", { d: "M200,40H56A16,16,0,0,0,40,56V200a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Zm0,80H136V56h64ZM120,56v64H56V56ZM56,136h64v64H56Zm144,64H136V136h64v64Z" }, null, -1)
      ]))) : n(H) === "thin" ? (o(), e("g", g, t[5] || (t[5] = [
        l("path", { d: "M200,44H56A12,12,0,0,0,44,56V200a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V56A12,12,0,0,0,200,44Zm4,12v68H132V52h68A4,4,0,0,1,204,56ZM56,52h68v72H52V56A4,4,0,0,1,56,52ZM52,200V132h72v72H56A4,4,0,0,1,52,200Zm148,4H132V132h72v68A4,4,0,0,1,200,204Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
